import React from "react";
import styles from "./anchor-link.module.css";

export interface AnchorLinkProps {
  to: string;
  className?: string;
  openNewTab?: boolean;
  testName?: string;
  options?: {
    button: boolean;
  };
  onClick?: () => void;
  disabled?: boolean;
  anchorDisabled?: boolean;
}

export const AnchorLink: React.FC<AnchorLinkProps> = ({
  to,
  className,
  openNewTab,
  children,
  testName,
  options,
  onClick,
  disabled = false,
  anchorDisabled = false,
}) => {
  if (openNewTab !== undefined) {
    if ((openNewTab as unknown as string) === "false") {
      openNewTab = false;
    }

    if ((openNewTab as unknown as string) === "true") {
      openNewTab = true;
    }
  }

  let _className = className || "";

  if (options && options.button) {
    _className += ` ${styles.button} ${styles.compact}`;
  }

  if (disabled) {
    _className += ` ${styles.disabled}`;
  }

  // if (size && styles[size]) {
  //   const sizeClass = styles[size];
  //
  //   if (sizeClass) {
  //     _className += ` ${sizeClass}`;
  //   }
  // }

  if (!to) {
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      <button
        data-qa={testName}
        className={_className}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        {children}
      </button>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      data-qa={testName}
      target={openNewTab ? "_blank" : ""}
      rel={openNewTab ? "noopener noreferrer" : ""}
      href={to}
      className={
        anchorDisabled ? _className + ` ${styles.anchorDisabled}` : _className
      }
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {children}
    </a>
  );
};
